import styled from 'styled-components';
import { NavLink as Link } from 'react-router-dom';
import { BaseStyle } from 'modules/Core/Common/Links/Base.styles';

const SytledLink = styled((props) => <Link {...props} />)`
  ${BaseStyle}
`;

export { SytledLink };
